const deepAssign = (target, source) => {
  for (const [key, value] of Object.entries(source ?? {})) {
    target[key] =
      typeof value === 'object' && value.constructor === Object ? deepAssign(target[key] ?? {}, value) : value;
  }
  return target;
};

export default (target, ...sources) => sources.reduce((target, source) => deepAssign(target, source), target);
